import {
    CONFIRMED_GET_PANCHKARMA_USERS,
    CONFIRMED_ADD_PANCHKARMA_USER,
    CONFIRMED_UPDATE_PANCHKARMA_USER,
    CONFIRMED_DELETE_PANCHAKRMA_USER,
} from "./UserType";
import {
    getPanchkarmaUsers,
    addPanchkarmaUser,
    updatePanchkarmaUser,
    deletePanchkarmaUser,
    formatPanchkarmaUsers,
} from "../../../services/PanchkarmaServices/UserService";
import swal from "sweetalert";
import { handleError, handleSuccess, showErrorAlert } from "../../../services/ErrorHandlingService";

// Get token
function getAuthToken(getState) {
    const stateToken = getState().auth?.authKey;
    if (stateToken) return stateToken;
    const storedUser = localStorage.getItem("userDetails");
    return storedUser ? JSON.parse(storedUser).token : null;
}
''
// export function getAdminUsersAction(pagination = false, pageid = 0, search_by = "", search_keyword = "",sort_by ="", sort_order = "") {
//   return async (dispatch, getState) => {
//     try {
//       const response = await getAdminUsers(pagination, pageid, search_by, search_keyword,sort_by,sort_order);

//       if (response && response.status === 200 && response.data) {
//         if (response.data.status === "success" && response.data.data) {
//           const adminUsers = formatAdminUsers(response.data.data);
//           dispatch({ type: CONFIRMED_GET_ADMIN_USERS, payload: adminUsers });
//         } else {
//           handleError("Failed to get AdminUsers: Server error");
//         }
//       } else {
//         handleError("Failed to get AdminUsers: Network error");
//       }
//     } catch (error) {
//       console.error("API Error:", error.response || error);
//       showErrorAlert("Failed to get AdminUsers");
//     }
//   };
// }

// New: Add Admin User Action
export function getPanchkarmaUsersAction(
    pagination = false,
    pageid = 0,
    search_by = "",
    search_keyword = "",
    sort_by = "",
    sort_order = "",
    is_panchkarma = "Yes"
) {
    return async (dispatch, getState) => {
        try {
            const token = getAuthToken(getState);
            const response = await getPanchkarmaUsers(
                pagination,
                pageid,
                search_by,
                search_keyword,
                sort_by,
                sort_order,
                is_panchkarma = "Yes",
                token
            );

            if (response && response.status === 200 && response.data) {
                if (response.data.status === "success" && response.data.data) {
                    const panchkarmaUsers = formatPanchkarmaUsers(response.data.data);
                    dispatch({
                        type: CONFIRMED_GET_PANCHKARMA_USERS,
                        payload: {
                            panchkarmaUsers: panchkarmaUsers,
                            num_rows: response.data.num_rows || 0
                        }
                    });
                } else {
                    handleError("Failed to get PanchkarmaUsers: Server error");
                }
            } else {
                handleError("Failed to get PanchkarmaUsers: Network error");
            }
        } catch (error) {
            console.error("API Error:", error.response || error);
            showErrorAlert("Failed to get PanchkarmaUsers");
        }
    };
}


export function addPanchkarmaUserAction(userData, history) {
    return async (dispatch) => {
        try {
            const panchkarmaUser = {
                role_id: userData.role_id,
                admin_name: userData.admin_name,
                admin_username: userData.admin_username,
                admin_password: userData.admin_password,
                admin_cpassword: userData.admin_cpassword,
                admin_email: userData.admin_email,
                admin_mobile: userData.admin_mobile,
                admin_status: userData.admin_status,
                //   disease_ids: JSON.stringify(
                //     Array.isArray(userData.disease_ids)
                //       ? userData.disease_ids
                //       : userData.disease_ids
                //         ? [userData.disease_ids]
                //         : []
                //   ),
                //   daily_calling_capacity: userData.daily_calling_capacity || undefined,
                //   max_active_patients: userData.max_active_patients || undefined,
            };
            console.log(panchkarmaUser);
            let response = await addPanchkarmaUser(panchkarmaUser);
            console.log(response);
            if (response && response.status === 200 && response.data) {
                const data = response.data;
                dispatch({ type: CONFIRMED_ADD_PANCHKARMA_USER, payload: panchkarmaUser });
                if (history) history.push("/add-user");
                handleSuccess("PanchkarmaUser created successfully!");
            } else {
                showErrorAlert("Failed to create PanchkarmaUser");
            }
        } catch (error) {
            console.error(error);
            showErrorAlert("Failed to create PanchkarmaUser");
        }
    };
}

export function updatePanchkarmaUserAction(panchkarmaUser, panchkarmaId, history) {
    return async (dispatch) => {
        try {
            let response = await updatePanchkarmaUser(panchkarmaUser, panchkarmaId);
            if (response) {
                dispatch({ type: CONFIRMED_UPDATE_PANCHKARMA_USER, payload: panchkarmaUser });
                if (history) history.push("/users");
            } else {
                showErrorAlert("Failed to update users");
            }
        } catch (error) {
            console.log(error);
            showErrorAlert("Failed to update users");
        }
    };
}

export function deletePanchkarmaUserAction(panchkarmaUser, history) {
    return async (dispatch) => {
        try {
            await deletePanchkarmaUser({ delete_user_id: panchkarmaUser.admin_id });
            dispatch({
                type: CONFIRMED_DELETE_PANCHAKRMA_USER,
                payload: { admin_id: panchkarmaUser.admin_id },
            });
            if (history) history.push("/users");
            //handleSuccess("AdminUser deleted successfully!");
        } catch (error) {
            console.error(error);
            showErrorAlert("Failed to delete PanchkarmaUser");
        }
    };
}
